import React, { useContext, useEffect, useMemo, useState } from "react";
import styles from "../snapshots.module.css";
import TableErrorState from "@/components/States/TableErrorState";
import clsx from "clsx";
import { Dropdown, Modal, Button, DropdownButton } from "react-bootstrap";
import Tooltip from "@/components/tooltip/tooltip";
import removeIcon from "@/assets/img/cancel_Icon.svg";
import Pagination from "@/components/pagination/pagination.component";
import HistoryModal from "./state_change/historyModal";
import { useGetHistory } from "@/services/snapshots/getAcceptDismissHistory.repo";
import ScenariosErrorState from "@/components/States/scenariosErrorState";
import disablejira from "@/assets/img/jiradisable.svg";
import Viajira from "@/assets/img/viajira.svg";
import retaindisable from "@/assets/img/reataindisable.svg";
import retain from "@/assets/img/retainSnap.svg";
import DoneIcon from "@/assets/img/doneStateChange.svg";

import {
  API_LOADING_ERROR,
  API_NO_DATA_FOUND_ERROR,
  API_NO_DATA_FOUND_FOR_FILTERS_ERROR,
  API_NOT_FOUND_ERROR,
} from "@/lib/errors/error-constants";
import download from "@/assets/img/download.svg";
import menuicon from "@/assets/img/menu.svg";
import { UseSnapshotsDownload } from "@/services/snapshots/getSnapshotDownload.repo";
import { useSearchParams } from "react-router-dom";
import DropdownComponent from "@/common/DropdownComponent";
import downlaodVM from "@/assets/img/downloadVM.svg";
import { OverlayTrigger, Tooltip as ReactTooltip } from "react-bootstrap";
import { ToolTipComponent } from "@/page-components/cost-explorer/components/cost-explorer-header.component";
import CurrencyFormatter from "@/lib/value-converison";
import { SnapshotContext } from "../snap.contex";

const DiscardedTable = ({
  historTableListError,
  historTableLoading,
  discardedData,
  name,
  service,
  copy,
}) => {
  const [copiedResourceId, setCopiedResourceId] = useState(null);
  const [showCopyMessage, setShowCopyMessage] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [enableHistory, setEnableHistory] = useState(false);
  const [savingId, setSavingId] = useState(null);
  const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get("page");
  const itemsPerPage = searchParams.get("itemsPerPage");


  const context = useContext(SnapshotContext);
  const handleMouseEnter = (index) => {
    setHoveredRowIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredRowIndex(null);
  };

  // useEffect(()=>{
  //   setSelectedResourceType("Deleted")

  // },[])

  const handleCopyClick = (snapshotId) => {
    const textarea = document.createElement("textarea");
    textarea.value = snapshotId;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    setCopiedResourceId(snapshotId);
    setCopiedResourceId(snapshotId);
    setShowCopyMessage(true);

    setTimeout(() => {
      setShowCopyMessage(false);
    }, 5000);
  };
  const queryParam = useMemo(() => {
    return {
      service,
      id: savingId,
    };
  }, [service, savingId]);

  const { data: historyData } = useGetHistory(queryParam);

  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleHistoryModal = (savingid) => {
    setEnableHistory(Boolean(savingid));
    setSavingId(savingid);
  };

  const handleCloseforHistory = () => {
    setEnableHistory(undefined);
    setSavingId(undefined);
  };

  const downloadQuery = useMemo(() => {
    const parsedPage = !Number.isNaN(parseInt(page)) ? parseInt(page) : 1;
    const parsedItemsPerPage = !Number.isNaN(parseInt(itemsPerPage))
      ? parseInt(itemsPerPage)
      : 10;
      const accounts = context?.selectedAccounts?.length
      ? context.selectedAccounts.map((e) => e.id)
      : undefined;

    const regions = context?.selectedRegions?.length
      ? context.selectedRegions.map((e) => e.id)
      : undefined;

    const diskIds = context?.selectedDisk?.length
      ? context.selectedDisk.map((e) => e.id)
      : undefined;

    const resourceGroupNames = context?.selectedResourceGroup?.length
      ? context?.selectedResourceGroup.map((e) => e.id)
      : undefined;
    return {
      recordsPerPage: parsedItemsPerPage || 10,
      orderBy: "snapshot_id",
      desc: searchParams.get("desc") || "true",
      page: parsedPage || 1,
      accounts,
      regions,
      diskIds,
      service,
      resourceGroupNames,
      toDate: context?.toDate,
      fromDate: context?.fromDate,
      period: context?.selectMonthRange.toLowerCase(),
      tableName: "history-download",
      limit: parsedItemsPerPage || 10,
    };
  }, [context?.fromDate, context?.selectMonthRange, context.selectedAccounts, context.selectedDisk, context.selectedRegions, context?.selectedResourceGroup, context?.toDate, itemsPerPage, page, searchParams, service]);
  const { mutate: downloadMutate,isPending: downLaodLoading } = UseSnapshotsDownload(downloadQuery);

  const handleDownloadClick = () => {
    downloadMutate(downloadQuery);
  };




  useEffect(()=>{
    if(downLaodLoading){
      document.body.style.cursor="wait"
    }else{
      document.body.style.cursor = "default"
    }
    return () => {
      document.body.style.cursor = 'default';
    };
  
  },[downLaodLoading])

  return (
    <>
        <div className={styles.Chart_table_section} style={{ width: "100%",paddingBottom:"30px" }}>
          {historTableLoading && <TableErrorState />}
          {historTableListError && (
            <ScenariosErrorState
              error={historTableListError.message}
              messageConfig={{
                [API_NO_DATA_FOUND_FOR_FILTERS_ERROR]: {
                  message: "No Data Available for Selected Filters",
                  additionalMessage:
                    "It looks like there are no data matching your filter criteria. Please try adjusting your filters to explore other options.",
                },
                [API_NO_DATA_FOUND_ERROR]: {
                  message: "No Data Available",
                  additionalMessage:
                    "We couldn’t retrieve data at this moment. This might be due to an absence of data or a temporary issue. Please try again later.",
                },
                [API_LOADING_ERROR]: {
                  message: "Oops!",
                  additionalMessage:
                    "We encountered a problem loading your data. Please ensure a stable internet connection and try again. If the issue persists, contact support.",
                },
                [API_NOT_FOUND_ERROR]: {
                  message: "404 Error",
                  additionalMessage:
                    "We couldn’t find the data you’re looking for. This might be due to a temporary issue or incorrect resource. Please check back later or contact support if the problem persists.",
                },
              }}
            />
          )}

          {discardedData &&
            discardedData?.snapshots &&
            discardedData?.snapshots?.length > 0 && (
              <>
                <div className={styles.snap_Heading_section}>
                  <div className={styles.justified_space}>
                    <span className={styles.heading_text_body}>
                      Deleted Snapshots Details ({discardedData?.count || 0})
                    </span>
                    <div className={styles.menu_icon_css1} style={{cursor:downLaodLoading?"wait":"pointer"}}>
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <ReactTooltip id="tooltip">
                            Download as CSV
                          </ReactTooltip>
                        }
                      >
                        <span
                          className={styles.downloadButton}
                          onClick={handleDownloadClick}
                        >
                          <img src={downlaodVM} alt="" />
                        </span>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
                <div className={styles.snap_table_section}>
                  <div
                    className={styles.table_container}
                    style={{ width: "100%", overflowX: "scroll" }}
                  >
                    <table
                      className="table "
                      style={{ margin: "0px", width: "100%" }}
                    >
                      <thead>
                        <tr
                          style={{
                            background: "#F6F6F6",
                            borderBottom: "1px solid #F6F6F6",
                          }}
                        >
                          <th className={styles.snap_th_class}>{name}</th>
                          <th className={styles.snap_th_class}>
                            Snapshot Name
                          </th>
                          {/* {service === "azure" && (
                            <th className={styles.snap_th_class}>
                              Resource Group
                            </th>
                          )} */}
                          <th className={styles.snap_th_class}>Snapshot ID</th>
                          <th className={styles.snap_th_class}>Region</th>
                          <th className={styles.snap_th_class}>Volume ID</th>
                          <th className={styles.snap_th_class}>Disk Size</th>
                          <th
                            className={clsx(
                              styles.snap_th_class,
                              styles.snap_th_class_center
                            )}
                          >
                            Snapshot Age
                          </th>
                          <th
                            className={clsx(
                              styles.snap_th_class,
                              styles.snap_th_class_center
                            )}
                          >
                            Storage Class
                          </th>
                        </tr>
                      </thead>
                      <tbody
                        style={{
                          borderRight: "white",
                          borderLeft: "white",
                        }}
                      >
                        {(discardedData?.snapshots || []).map((data, index) => (
                          <tr
                            className={clsx(
                              {
                                [styles.trhovered]: index === hoveredRowIndex,
                              },
                              styles.for_copy_hover
                            )}
                            key={index}
                            onMouseEnter={() => handleMouseEnter(index)}
                            onMouseLeave={handleMouseLeave}
                          >
                            <td
                              className={clsx(
                                styles.snap_table_data__Class,
                                "elipese"
                              )}
                              title={data?.account_name||data?.subscription_name}
                            >
                              {data?.account_name || data?.subscription_name ||"--"}
                            </td>
                            <td
                              className={clsx(
                                styles.snap_table_data__Class,
                                "elipese"
                              )}
                              title={data?.snapshot_name}
                            >
                              {data?.snapshot_name || "--"}
                            </td>
                            {/* {service === "azure" && (
                              <td
                                className={clsx(
                                  styles.snap_table_data__Class,
                                  "elipese"
                                )}
                                title={data?.resourceGroupName}
                              >
                                {data?.resourceGroupName || "NA"}
                              </td>
                            )} */}
                            <td
                              className={clsx(styles.snap_table_data__Class)}
                              title={data?.snapshotId}
                              style={{ marginRight: "8px" }}
                            >
                              <span
                                style={{
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                  maxWidth: "150px",
                                  display: "inline-block",
                                  lineHeight: "1.2",
                                }}
                              >
                                {data?.snapshot_id || "NA"}
                              </span>
                              <span
                                className={`${styles.snap_copy_icon} ${
                                  copiedResourceId === data?.snapshot_id
                                    ? "visible"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleCopyClick(data?.snapshot_id)
                                }
                              >
                                <img src={copy} alt="" />
                              </span>
                            </td>
                            <td
                              className={clsx(
                                styles.snap_table_data__Class,
                                "elipese"
                              )}
                            >
                              {data?.region || 0}
                            </td>
                            <td
                              className={clsx(
                                styles.snap_table_data__Class,
                                styles.truncate,
                                "elipese"
                              )}
                              title={data?.diskid}
                            >
                              {data?.diskid !== null ? data?.diskid:"--"}
                            </td>
                            <td className={styles.snap_table_data__Class}>
                              {data?.disk_size || 0}-GB
                            </td>
                            <td
                              className={clsx(
                                styles.snap_table_data__Class,
                                styles.snapshot_col_center
                              )}
                            >
                              {data?.snapshot_age || 0}
                            </td>
                            <td
                              className={clsx(
                                styles.snap_table_data__Class,
                                styles.snapshot_col_center,
                                styles.snapshot_col_weight,
                                // data?.snapshotClass === "ARCHIVE" &&
                                //   styles.snapshot_archived,
                                data?.storage_class !== "Unarchive" &&
                                  data?.storage_class !== null &&
                                  styles.snapshot_unarchived
                              )}
                              style={{
                                color:
                                  data?.storage_class === "ARCHIVE"
                                    ? "#ed9615"
                                    : "#056ee5",
                              }}
                            >
                              {data?.storage_class
                                ? String(data.storage_class).toUpperCase() ===
                                  "ARCHIVE"
                                  ? "Archive"
                                  : "Standard"
                                : "NA"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className={styles.container_secTable}>
                    <div
                      className={styles.table_container}
                      style={{ width: "100%" }}
                    >
                      <table
                        className="table "
                        style={{ margin: "0px", width: "100%" }}
                      >
                        <thead>
                          <tr
                            style={{
                              background: "#F6F6F6",
                              borderBottom: "1px solid #F6F6F6",
                            }}
                          >
                            <th
                              className={clsx(
                                styles.snap_th_class,
                                styles.snap_th_class_center
                              )}
                            >
                              Deleted On
                            </th>
                            <th
                              className={clsx(
                                styles.snapshot_col_end,
                                styles.snap_th_class
                              )}
                            >
                              Actual Savings
                            </th>
                            <th
                              className={clsx(
                                styles.snapshot_col_end,
                                styles.snap_th_class
                              )}
                              style={{textAlign:"start"}}
                            >
                              Status
                            </th>
                            {/* <th className={styles.snap_th_class}></th> */}
                          </tr>
                        </thead>
                        <tbody
                          className={styles.snap_table_data__Class}
                          style={{
                            borderRight: "white",
                            borderLeft: "white",
                          }}
                        >
                          {(discardedData?.snapshots || []).map(
                            (data, index) => (
                              <tr
                                className={clsx({
                                  [styles.trhovered]: index === hoveredRowIndex,
                                })}
                                key={index}
                                onMouseEnter={() => handleMouseEnter(index)}
                                onMouseLeave={handleMouseLeave}
                              >
                                <td
                                  className={clsx(
                                    styles.snap_table_data__Class,
                                    styles.snapshot_col_weight,
                                    styles.snapshot_col_end
                                  )}
                                >
                                 {data?.deleted_on !== null ? new Date(data?.deleted_on).toISOString().split('T')[0] : "--"}
                                </td>
                                <td
                                  className={clsx(
                                    styles.snap_table_data__Class,
                                    styles.snapshot_col_weight,
                                    styles.snapshot_col_end
                                  )}
                                >
                                  <ToolTipComponent data={data?.actual_saving}>
                                    {data?.actual_saving === null && "$0"}
                                    {data?.actual_saving != null &&
                                      data?.actual_saving < 0.1 &&
                                      "< $0.1"}
                                    {data?.actual_saving > 0.1 && (
                                      <CurrencyFormatter
                                        value={data?.actual_saving}
                                        hideDollar={false}
                                      />
                                    )}
                                  </ToolTipComponent>
                                </td>
                                <td
                                  className={clsx(
                                    styles.snap_table_data__Class,
                                    styles.snapshot_col_weight,
                                    styles.snapshot_col_end
                                  )}
                                >
                                  {data?.status !== null ? (
                                    <>
                                      {data?.status == "retained" && (
                                        <span className={styles.badgeName}>
                                          {" "}
                                          Active
                                        </span>
                                      )}
                                      {data?.status == "open" && (
                                        <span className={styles.badgeName}>
                                          {" "}
                                          Open
                                        </span>
                                      )}
                                      {data?.status == "accepted" && (
                                        <span
                                          className={styles.badgeNamePending}
                                        >
                                          Pending Approval
                                        </span>
                                      )}
                                      {data?.status == "in_progress" && (
                                        <span
                                          className={styles.badgeNameProgress}
                                        >
                                          In Progress
                                        </span>
                                      )}
                                      {data?.status == "deleted" && (
                                        <span className={styles.badgeNameDone}>
                                          {" "}
                                          <img src={DoneIcon} alt=""></img>{" "}
                                          Deleted
                                        </span>
                                      )}
                                    </>
                                  ) : (
                                    <span className={styles.badgeName}>--</span>
                                  )}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <Pagination totalItems={discardedData?.count || 0} />
              </>
            )}
        </div>
      {showCopyMessage && (
        <div className={styles.copyMessage}>Copy to Clipboard!</div>
      )}{" "}
      {Boolean(savingId) && (
        <Modal
          show={enableHistory}
          onHide={handleCloseforHistory}
          //   contentClassName={styles.modalContent}
          centered
        >
          <HistoryModal
            historyData={historyData}
            enableHistory={enableHistory}
          />
        </Modal>
      )}
    </>
  );
};

export default DiscardedTable;
